<template lang="html">
  <!--<div class="vue-sprite">-->
    <canvas
      :id='id'
      :width="width"
      :height="height"
      class="canvas"
      ref="vue-sprite-canvas"
    ></canvas>
  <!--</div>-->
</template>

<script>
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'v-sprite',
  props: {
    spritesheet: {
      required: true,
      type: String,
      default: ''
    },
    json: {
      required: true,
      type: Object,
      default: {}
    },
    fps: {
      type: Number,
      default: 30
    },
    /*autoplay: {
      type: Boolean,
      default: true
    },
    yoyo: {
      type: Boolean,
      default: false
    },*/
    id: {
      type: String,
      default: 'vue-sprite'
    }
  },
  data () {
    return {
      animations: {},
      currentAnimation: null,
      height: 0,
      width: 0,
      default: null,
      context: null,
      sprite: null,
      now: 0,
      then: 0,     
      animationFrameID: null
      //yoyodirection: 0
    }
  },
  mounted () {
    this.json.anims.forEach((anim) => {
      this.animations[anim.key] = anim
    })
    /*this.json.frames.forEach((frame) => {
      this.frames.push({
        name: frame.filename,
        x: frame.frame.x,
        y: frame.frame.y,
        w: frame.frame.w,
        h: frame.frame.h
      })
    })*/
    //this.frames.sort((a, b) => a.filename < b.filename)
    this.width = this.json.meta.size.w
    this.height = this.json.meta.size.h
    this.default = this.json.meta.default
  },
  created () {
    this.$nextTick(() => {
      this.sprite = new Image()
      this.sprite.src = this.spritesheet
      this.sprite.onload = ({ target }) => { this.init(target) }
    })
  },
  methods: {
    init (img) {
      this.context = this.$refs['vue-sprite-canvas'].getContext('2d')
      if(this.default) {
        if(!this.default.frame || this.default.frame < 0) {
          this.loop(this.default.key)
        } else {
          this.goto(this.default.key, this.default.frame)
        }        
      }
      //this.autoplay && this.loop()
    },
    render () {
      this.context && this.context.clearRect(0, 0, this.width, this.height)
      const index = Math.abs(this.currentAnimation.index % this.currentAnimation.length)
      const x = this.currentAnimation.frames[index].frame.x
      const y = this.currentAnimation.frames[index].frame.y
      this.context && this.context.drawImage(this.sprite, x, y, this.width, this.height, 0, 0, this.width, this.height)
      /*if (this.yoyo && this.currentIndex % this.length === 0 && this.currentIndex) {
        this.yoyodirection = Number(!this.yoyodirection)
      }
      const index = Math.abs((this.currentIndex % this.length) - (this.length * this.yoyodirection))*/
    },
    anim () {
      this.now = Date.now()
      const delta = (this.now - this.then)
      if (delta > (1000 / this.fps)) {
        this.then = this.now - (delta % (1000 / this.fps))
        this.render()
        this.currentAnimation.index += this.currentAnimation.rev ? -1 : 1
      }
      if(this.animationFrameID && !this.currentAnimation.loop) {
        if(this.currentAnimation.rev) {
          if(this.currentAnimation.index < 0) {
            if(this.currentAnimation.callback) this.currentAnimation.callback()
            return
          }
        } else {
          if(this.currentAnimation.index > this.currentAnimation.length-1) {
            if(this.currentAnimation.callback) this.currentAnimation.callback()
            return
          }
        }
      }
      /*if(this.animationFrameID && !this.currentAnimation.loop && this.currentAnimation.index > this.currentAnimation.length-1) {
        if(this.currentAnimation.callback) this.currentAnimation.callback()
        return
      }*/

      this.animationFrameID = window.requestAnimationFrame(this.anim)
    },
    goto (name, frame) {
      this.stop()
      this.currentAnimation = this.animations[name]
      this.currentAnimation.index = frame
      this.currentAnimation.length = this.animations[name].frames.length
      this.render()
    },
    playto (name, frame, onComplete) {
      this.stop()
      this.currentAnimation = this.currentAnimation || this.animations[name]
      this.currentAnimation.index = this.currentAnimation.index || 0
      this.currentAnimation.length = frame
      this.currentAnimation.callback = onComplete
      this.anim()
    },
    reset() {
      this.currentAnimation = null
    },
    rev (name) {
      this.currentAnimation = this.currentAnimation || this.animations[name]
      this.currentAnimation.index = (this.currentAnimation.key != name) ? this.animations[name].frames.length-1 : this.currentAnimation.index
      this.currentAnimation.length = this.animations[name].frames.length-1
      this.currentAnimation.rev = true
      this.anim()
    },
    loop (name) {
      this.currentAnimation = this.animations[name]
      this.currentAnimation.index = 0
      this.currentAnimation.loop = true
      this.currentAnimation.length = this.animations[name].frames.length
      this.anim()
    },
    stop () {
      window.cancelAnimationFrame(this.animationFrameID)
    },    
    play (name, onComplete) {
      this.stop()
      this.currentAnimation = this.currentAnimation || this.animations[name]
      this.currentAnimation.index = this.currentAnimation.index || 0
      this.currentAnimation.length = this.animations[name].frames.length
      this.currentAnimation.callback = onComplete
      this.anim()
    }
  }
})
export default class SpriteAnimator extends Vue {}
</script>

<style scoped lang="stylus">
/*.canvas
  position absolute !important
  margin auto
  left 0
  right 0
  bottom 0
  top 0*/
</style>